import React, { useEffect } from 'react';
import TermsAndConditions from './TermsAndConditions';

const TracsessOrganizeTerms: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TermsAndConditions
      appName="Tracsess Organize"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/organize/TOS_Tracsess_Organize.pdf"
      title="Tracsess Organize - Terms and Conditions"
    />
  );
};

export default TracsessOrganizeTerms; 